








import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LanguageDto, EntityDto } from "@/server/app.dtos";
import { ActivitiesService } from "@/services/api/activities.service";

@Component
export default class EntityDetailDashboardPage extends Vue {
  @Prop() entity!: EntityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  isLoading: boolean = false;
  activitiesService: ActivitiesService = new ActivitiesService();

  async created() {
    await this.Load();
  }

  async Load() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
  }
}
